import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

declare const google: any;
var map: any;


@Component({
  selector: 'app-alarm-ubication',
  templateUrl: './alarm-ubication.component.html',
  styleUrls: ['./alarm-ubication.component.css']
})
export class AlarmUbicationComponent implements OnInit {

  plate : any;
  alarm : any;
  driver : any;

  constructor(
    private route: ActivatedRoute,

  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(params)
      if (params.lat != undefined && params.long) {
        this.plate = params.plate
        this.alarm = params.alarm
        this.driver = params.driver
        this.initMap(params.lat.replace(",", "."), params.long.replace(",", "."))
      }
    });
  }

  initMap(lati, longi) {
    var uluru = {lat: +lati, lng: +longi};
    map = new google.maps.Map((<HTMLInputElement>document.getElementById('initMap')), {
      zoom: 7,
      center: new google.maps.LatLng(lati, longi)
    });
    var marker = new google.maps.Marker({position: uluru, map: map});
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/alarm-ubication/alarm-ubication.component.ts